var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder_Network",
    "data-name": "Folder Network"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 40a1 1 0 0 1 -1-1v-5a3.0033 3.0033 0 0 1 3-3h22a1 1 0 0 1 0 2h-22a1.0006 1.0006 0 0 0 -1 1v5a1 1 0 0 1 -1 1z",
    fill: "#337fef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 42a1 1 0 0 1 -1-1v-7a1.0006 1.0006 0 0 0 -1-1h-22a1 1 0 0 1 0-2h22a3.0033 3.0033 0 0 1 3 3v7a1 1 0 0 1 -1 1z",
    fill: "#337fef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 40h-13.67a1 1 0 0 0 -.8321 1.5547l2.67 4a1 1 0 0 0 .8321.4453h15a1 1 0 0 0 1-1 5.0059 5.0059 0 0 0 -5-5z",
    fill: "#ffb125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 44h-14.4648l-2.8135-4.2148a3.9958 3.9958 0 0 0 -3.3317-1.7852h-5.39a3.0033 3.0033 0 0 0 -3 3v18a5.0059 5.0059 0 0 0 5 5h20a5.0059 5.0059 0 0 0 5-5v-14a1 1 0 0 0 -1-1z",
    fill: "#fcd354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 40h-13.67a1 1 0 0 0 -.8321 1.5547l2.67 4a1 1 0 0 0 .8321.4453h15a1 1 0 0 0 1-1 5.0059 5.0059 0 0 0 -5-5z",
    fill: "#ffb125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63 44h-14.4648l-2.8135-4.2148a3.9958 3.9958 0 0 0 -3.3317-1.7852h-5.39a3.0033 3.0033 0 0 0 -3 3v18a5.0059 5.0059 0 0 0 5 5h20a5.0059 5.0059 0 0 0 5-5v-14a1 1 0 0 0 -1-1z",
    fill: "#fcd354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 31a1 1 0 0 1 -1-1v-5a1 1 0 0 1 2 0v5a1 1 0 0 1 -1 1z",
    fill: "#337fef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 2h-13.67a1 1 0 0 0 -.8321 1.5547l2.67 4a1 1 0 0 0 .8321.4453h15a1 1 0 0 0 1-1 5.0059 5.0059 0 0 0 -5-5z",
    fill: "#ffb125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 6h-14.4648l-2.8135-4.2148a3.9958 3.9958 0 0 0 -3.3317-1.7852h-5.39a3.0033 3.0033 0 0 0 -3 3v18a5.0059 5.0059 0 0 0 5 5h20a5.0059 5.0059 0 0 0 5-5v-14a1 1 0 0 0 -1-1z",
    fill: "#fcd354"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#48acff",
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.ae884e2c6139efa4c613bf84305d342f.svg";
export { ForwardRef as ReactComponent };